import AxiosClient from "../../services/axios.services";

class CenterCostServices {
  getCenterCost = (params, type) =>
    AxiosClient.get(type === 1 ? `/api/app/Formal_Centro_Costo/` : `/api/app/Funcional_Centro_Costo/`, {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  saveCenterCost = (data, type) =>
    AxiosClient.post(type === 1 ? `/api/app/Formal_Centro_Costo/` : `/api/app/Funcional_Centro_Costo/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  editCenterCost = (id, data, type) =>
    AxiosClient.put(type === 1 ? `/api/app/Formal_Centro_Costo/${id}/` : `/api/app/Funcional_Centro_Costo/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  deleteCenterCost = (id, type) =>
    AxiosClient.delete(type === 1 ? `/api/app/Formal_Centro_Costo/${id}/` : `/api/app/Funcional_Centro_Costo/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new CenterCostServices();
